export default __webpack_public_path__ + "static/media/indexxWalletLogo.a9bc34d6.png";